module.exports = __webpack_public_path__ + "media/popcorn.ab137022.mp3";